import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { SubscriptionFeeMapper } from "@domains/mapper/Reports/SubscriptionFee/SubscriptionFee";
import { SubscriptionPopupMapper } from "@domains/mapper/Reports/SubscriptionFee/SubscriptionPopup";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class SubscriptionFeeRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getSubscriptionFee(req) {
        const url = new URL(urlConfig.subscription);
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", req.accountId);
        url.searchParams.append("subType", req.subType);
        let subscriptionFeeData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return SubscriptionFeeMapper(subscriptionFeeData.data);
    }
    async getRateBasedSubscriptionPopup(req) {
        const url = new URL(urlConfig.subscription + "/rateBasedConsumption");
        const accountCode = await this.accountDetails.getAccountCode();
        url.searchParams.append("accountId", accountCode);
        url.searchParams.append("schemeRefNo", req.schemeRefNo);
        const subscriptionPopupuData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        return SubscriptionPopupMapper(subscriptionPopupuData.data);
    }
    addSearchParams(url, searchparams) {
        if (!searchparams)
            return url;
        searchparams.map((param) => {
            url.searchParams.append(param.key, param.value);
        });
        return url;
    }
    async emailSubscriptionPopup(emailRequestData) {
        var _a, _b, _c, _d, _e;
        const accountCode = await this.accountDetails.getAccountCode();
        if (!accountCode)
            return;
        let url = new URL(urlConfig[(_a = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _a === void 0 ? void 0 : _a.firstPart] +
            ((_b = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _b === void 0 ? void 0 : _b.secondPart) +
            (((_c = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _c === void 0 ? void 0 : _c.thirdPart)
                ? (_d = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _d === void 0 ? void 0 : _d.thirdPart
                : "/email"));
        url = this.addSearchParams(url, (_e = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.searchParams) !== null && _e !== void 0 ? _e : []);
        return await this.http
            .makeApiCall({
            method: "POST",
            url: url.toString(),
            body: emailRequestData.requestBody,
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        })
            .then((result) => {
            return result;
        });
    }
}
export default SubscriptionFeeRepository;
